const data = {
  slides: [
    {
      "Slide Number": "1",
      "Title":
      "'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison"
      +"\r\n\r\n January 23, 2023",
      "Screen Image":"assets/AlSina_Drone.png",
      "Text Image":"assets/AlSina_Drone.png"
    },
    {
      "Slide Number": "2",
      "Text Image":"Frames/AlSina_Frame000.png",
      "Screen Image":"assets/AlSina_Drone.png",
      "Title":
      "'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison"
      +"\r\n\r\n January 23, 2023"
    },
    {
      "Slide Number": "3",
      "Card Empty":".",
      "Scroll Video":"120",
    },
    {
      "Slide Number": "4",
      "Card Content":
      "In January 2022, the Islamic State carried out its deadliest raid in years - storming a Syrian prison where thousands of its fighters were held."
      +"\r\n\r\n Around 500 people died in ten days of fighting, with a number of senior ISIS commanders alleged to have escaped.",
      "Scroll Video":"10",
      "Graphic Material":"Warning: This article contains graphic material"
    },
    {
      "Slide Number": "5",
      "Card Content":
      "A year-long investigation by Airwars and <l>Vice News(https://www.youtube.com/watch?v=8yaDCwlgnIU)</l> used visual evidence, interviews and on the ground reporting to construct a 3D model of the prison and better understand the events of January 20th.",
      "Scroll Video":"10",
      "Graphic Material":"Warning: This article contains graphic material"
    },
    {
      "Slide Number": "6",
      "Card Content":
      "It found that the breakout came after years of overlapping failures by the international community, the US military, and its local partners.",
      "Scroll Video":"10",
    },
    {
      "Slide Number": "7",
      "Scroll Video":"100",
      "Text Image": "assets/DFrame058.png",
    },
    {
      "Slide Number": "8",
      "Text Title": "WATCH THE FULL DOCUMENTARY HERE",
      "Multiple Images": [{src: "assets/documentary_poster.png", url: "https://www.youtube.com/watch?v=8yaDCwlgnIU"}]
    },
     {
      "Slide Number": "9",
      "Text Title": "THREE YEARS BEFORE THE ATTACK",
      "Compare Slider": '{"src1":"assets/AlHoq.jpg", "src2":"assets/AlHoq2.jpg"}',
      "Text Long After":
      "When the Islamic State lost the last of its territory in 2019, tens of thousands of alleged former ISIS fighters and supporters were detained by the US-backed Syrian Democratic Forces (SDF) - a Kurdish-led alliance that controls the region."
      +"\r\n\r\n In addition to Iraqis and Syrians, citizens of more than 90 countries across the globe had come to the region. Nations largely refused to repatriate them – instead, they were thrown into vast camps in the Syrian desert.", 
      "Image Caption":
      "Growth of the Al-Hol camp for ISIS-linked detainees after the collapse of the Islamic State"
      +"\r\n\r\n Source: Maxar satellite images",
      "Text Image End": "assets/DFrame058.png",   
    },   
    {
      "Slide Number": "10",
      "Scroll Video":"120", 
      "Card Empty": ".",
    },
    {
      "Slide Number": "11",
      "Card Content":
      "The most notorious detention site was the Al-Sinaa Prison in Al-Hasakah, northern Syria. A former school building, it held around 4,000 alleged former ISIS fighters, none of whom have faced trial.",
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "12",
      "Card Content":
      "Detainees were held in five buildings. In the southernmost block were around 700 teenage boys - held without charge despite the protests of human rights organisations.",
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "13",
      "Scroll Video":"100",
      "Text Image": "assets/DFrame098.png",
    },
    {
    "Slide Number": "14",
    "Text Long":
    "Conditions at the prison were stark. Cells were overcrowded, with reports of more than 40 detainees per room. Tuberculosis and other diseases ran rampant."
    +"\r\n\r\n Storyful journalist Joanne Stocker-Kelly recalled a 2019 visit:",
    "Audio":
    "assets/Stocker_1.mp3",
    "Text Toggle Title":
    "Audio Transcript",
    "Text Toggle Content":
    '"The first thing that hit me when I walked into the room was the smell. There were just bodies of men covering the floor - they were on beds, they were on the floor itself, they were seated two or three next to each other.'
    +'\r\n\r\n A lot of the men were very visibly injured and were covered in bandages but the bandages maybe were not cleaned as they often should have been"'
    +"\r\n\r\n Source: Airwars interview", 
    "Multiple Images":[{src: "assets/Cells2019_1.png"},
    {src: "assets/Cells2019_2.png"}],
    "Image Caption":
    "Al-Sinaa Prison in 2019"
    +"\r\n\r\n Source: VICE News",
},
   {
   "Slide Number": "15",
   "Text Long":
   'In interviews with VICE News, SDF guards said they rarely entered the cells for fear of being overpowered. One warned it was a disaster "waiting to happen." There were not enough staff to run the facility properly, so prisoners were often involved in its maintenance - including cooking and helping run the medical clinic.'
   +"\r\n\r\n Stocker-Kelly said guards told her of regular shortfalls:",
   "Audio":
   "assets/Stocker_2.mp3",
   "Text Toggle Title":
   "Audio Transcript",
   "Text Toggle Content":
   '"I do not think that the [SDF] guards would want to treat people this way, even if they hated them. They were just incapable of having better conditions at that time. There were too many people, there probably was not enough money and they did not have enough space or security to make anything better"'
   +"\r\n\r\n Source: Airwars interview", 
   "Text Long After":
   "The situation at Al-Sinaa needed a policy solution from the US, which was providing tens of millions of dollars annually to fund, equip and train the SDF. But multiple US officials told Airwars and VICE News that dealing with the after-effects of ISIS’ defeat wasn't a priority in Washington - with President Donald Trump eager to withdraw as quickly as possible.",
  //  "Multiple Images": "assets/Trump_tweet.png",
   "Multiple Images": [{src: "assets/Trump_tweet.png"}],
   "Image Caption":
   "President Donald Trump's tweet in 2018"
   },
  ,{
    "Slide Number": "16",
    "Text Title": "TWO YEARS BEFORE THE ATTACK",
    "Text Long After":
    "At the prison, conditions continued to deteriorate. Between 2019 and 2021, there were at least five attempted breakouts. During one riot in 2020, detainees allegedly dug tunnels between cells." 
    +'\r\n\r\n Reports produced by the US-led Coalition against the Islamic State for the US Congress (<l>March 2020(https://media.defense.gov/2020/May/13/2002298979/-1/-1/1/LIG_OIR_Q2_MAR2020_GOLD_508_0513.PDF)</l>, <l>May 2020(https://media.defense.gov/2020/Aug/04/2002470215/-1/-1/1/LEAD%20INSPECTOR%20GENERAL%20FOR%20OPERATION%20INHERENT%20RESOLVE%20APRIL%201,%202020%20-%20JUNE%2030,%202020.PDF)</l>, <l> September 2020(https://media.defense.gov/2020/Nov/03/2002528608/-1/-1/1/LEAD%20INSPECTOR%20GENERAL%20FOR%20OPERATION%20INHERENT%20RESOLVE.PDF)</l>, <l>May 2021(https://media.defense.gov/2021/Aug/11/2002828689/-1/-1/1/LEAD%20INSPECTOR%20GENERAL%20FOR%20OPERATION%20INHERENT%20RESOLVE%20QUARTERLY%20REPORT%20APRIL%201,%202021%20%E2%80%93%20JUNE%2030,%202021.PDF)</l>) described regular unrest, with prisoners breaking down doors and digging holes between cells. One warned that “the risk of a mass breakout cannot be discounted.”',
    "Text Image End":"assets/CoalitionDocs.png",
  },
  {
    "Slide Number": "17",
    "Text Long": "SDF prison managers and senior officials regularly asked the Coalition for more funding to improve security, and for detainees to be put on trial in international courts."
    +"\r\n\r\n The Coalition provided some training, security cameras and reinforced doors, but calls for wider change went unanswered.",
    "Text Video": '{"src":"assets/Bawar_interview.mp4", "poster":"assets/Bawar_poster.png"}',
    "Image Caption":
    "Malak Ma'esh, known as Bawar, an SDF guard at the prison"
    +"\r\n\r\n Source: VICE News",
    "Text Long After":"The Coalition and the SDF sought funding to build a new bespoke prison facility—one that would be more secure, and comply with international standards for the treatment of prisoners."
    +"\r\n\r\n But the Trump administration had quietly introduced <l> a clause(https://tjaglcs.army.mil/mlr/the-fight-against-isis-has-changed-so-should-its-funding-source)</l> as part of the 2018 National Defense Authorisation Act (NDAA), placing a $4 million limit on funding for new infrastructure in northern Syria. In effect, this made it impossible for the US to fund the new facility.",
    },
    {
    "Slide Number": "18",
    "Text Title": "ONE YEAR BEFORE THE ATTACK",
    "Text Long After": "A year passed until - in late 2020 - work began on a new secure prison complex. The British government <l>announced(https://hansard.parliament.uk/commons/2021-03-04/debates/DC3BD59C-F7E3-41B3-885B-5932C6EDD817/Counter-DaeshUpdate) </l> it was funding it, as well as facilities for women and children detainees in Hasakah. In total the developments cost $20 million.", 
    "Text Image End": "Frames/AlSina_Frame099.jpg",
    },
    {
      "Slide Number": "19",
      "Scroll Video":"100", 
      "Card Empty":".",   
    },
    {
      "Slide Number": "20",
      "Scroll Video":"10",
      "Card Content":
      "The new section was built next to the existing prison.", 
    }, 
    {
      "Slide Number": "21",
      "Scroll Video":"10", 
      "Card Content":
      "The original facility had only a single sheet metal gate and thin brick walls, but the new section was properly fortified. It would have made a breakout far more difficult.",
    },  
    {
      "Slide Number": "22",
      "Scroll Video":"100", 
      "Text Image": "Frames/AlSina_Frame266.jpg",
    },  
    {
      "Slide Number": "23",
      "Text Title": "THREE MONTHS BEFORE THE ATTACK",
      "Text Long": "In August 2021, Paul Calvert - a top commander in the anti-ISIS Coalition - <l>told SDF officials(https://www.youtube.com/watch?v=q97HwOu-2Ko?t=122)</l> the new prison would be open by September."      
      +"\r\n\r\n But it was severely delayed, and still wasn't open by the time of the attack five months later.",      
      "Text Video": '{"src":"assets/weapon_destruction.mp4", "poster":"assets/destruction.png"}',
      "Image Caption":
      "Destruction of a vehicle rigged with explosives by the US-led Coalition in support of the SDF"
      +"\r\n\r\n Source: SDF Press Center", 
      "Text Long After": "In November 2021, Kurdish security forces seized a cache of weapons and explosives in the Syrian desert - announcing that they had foiled a planned raid on the prison."
      +"\r\n\r\n Field investigators at the weapons analysis group <l> Conflict Armament Research(https://www.conflictarm.com/)</l> (CAR) have now been able to compare markings on the weapons and ammunition used in the foiled November breakout attempt and in the January attack."
      +"\r\n\r\n We can reveal for the first time that they found key similarities between items seized from the IS cell in the November foiled prison attack and those recovered from ISIS operatives in the aftermath of the January prison break. These include lot numbers of ammunition manufactured as late as 2018."
      +"\r\n\r\n CAR's findings suggest the weapons were likely from the same ISIS stockpile - implying security forces had only partially foiled the November attack.",     
    },
    {
      "Slide Number": "24",
      "Text Long": "Authorities did take some steps to improve security at the prison - installing a blast wall between the complex and the main road. However in places it appears they used bricks to raise the level of the wall - including at the exact point where the eventual attack occurred.",
      "Multiple Images": [{src: "assets/BlastWall_2.png"}
      , {src: "assets/BlastWall_1.png"}],
      "Image Caption": "Sections of the new blast wall after the January 2022 attack"
      +"\r\n\r\n Source: Mohammed Hassan",
      "Text Long After": "By 2022, years of warnings had been ignored, the new, more secure facility was unoccupied, and countries were still largely refusing to take back their citizens."
      +"\r\n\r\n With the window for a potential breakout closing, ISIS attempted one last assault.",
    },
    {
      "Slide Number": "25",
      "Text Title": "THE ATTACK",
      "Text Image End": "Frames/AlSina_Frame267.jpg",
    },
    {
      "Slide Number": "26",
      "Scroll Video":"100",
      "Card Empty":".",   
    },
    {
      "Slide Number": "27",
      "Card Content":
      "Around 7:20pm on January 20th several fuel tankers were set ablaze - covering the compound with smoke and obscuring the attackers from Coalition aircraft.",    
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "28",
      "Card Content":
      "At the same time, a truck laden with explosives destroyed the main gate.",
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "29",
      "Card Content":
      "Further south, a second vehicle rammed into another gate.",
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "30",
      "Scroll Video":"100", 
      "Text Image": "Frames/AlSina_Frame517.jpg",  
    },
    {
      "Slide Number": "31",
      "Text Long": "At the same time as the explosions, hundreds of detainees rioted. Seemingly within minutes they were able to break out of their cells."
      +"\r\n\r\n Footage and images from inside the prison showed them setting fires, running towards the exits and arming themselves with weapons raided from the SDF offices. In one <l>video(https://twitter.com/jadogareshahrOZ/status/1486081682893680646)</l> they can be seen breaking through a cell wall using what looks like a heavy object."
      +"\r\n\r\n The guards and kitchen staff were quickly overwhelmed and dozens taken hostage. Detainees fled into the neighbourhoods around the prison – some were able to force their way into homes, while others remained on the loose or eventually surrendered. In a desperate attempt to quash the outbreak, the US-led Coalition carried out multiple airstrikes targeting escaped ISIS militants - badly damaging a number of buildings."
      +"\r\n\r\n SDF and American officials quickly claimed that hundreds of attackers entered the prison and freed the detainees. However, evidence suggests the prisoners escaped their cells without significant external help - pointing to failings in internal security."
      +"\r\n\r\n Airwars reviewed all publicly available footage and images after the attack, as well as hours of footage released by the SDF to VICE News. We sought to gather all evidence of external attackers by identifying militants wearing suicide vests - typically worn by fighters when conducting attacks.",
      "Text Image End": "Frames/AlSina_Frame734.jpg",  
    },
    {
      "Slide Number": "32",
      "Scroll Video":"100", 
      "Card Empty":".", 
    },
    {
      "Slide Number": "33",
      "Card Content":
      "In all publicly available footage we found no evidence of fighters from outside the prison entering the buildings.",
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "34",
      "Card Content":
      "We documented at least ten external attackers killed outside the walls, with reports of around another 20 killed in the surrounding neighbourhoods.", 
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "35",
      "Card Content":
      "This estimate is significantly smaller than the 150 external attackers claimed by the SDF.",
      "Scroll Video":"10",    
    },
    {
      "Slide Number": "36",
      "Scroll Video":"100", 
      "Text Image": "Frames/AlSina_Frame927.jpg",         
    },
    {
      "Slide Number": "37", 
      "Text Long": "During 10 days of fighting, at least 6,000 people fled their homes, while SDF and US forces locked the city down. Battles continued, with at least <l>140 homes razed to the ground(https://www.hrw.org/news/2022/11/01/syria-civilian-homes-demolished-security-operation)</l> in the following weeks."
      +"\r\n\r\n Around 500 people died, including approximately 300 detainees. 121 SDF guards died - some beheaded by ISIS militants. A number of senior ISIS figures were <l>reported to have escaped(https://twitter.com/HussamHamoud/status/1576898720909897728)</l>, though the SDF denies this."
      +"\r\n\r\n Even now, the exact identities and numbers of inmates in the prison is unknown, including the whereabouts and safety of the 700 juvenile prisoners. <l>According to the United Nations(https://www.ohchr.org/en/press-releases/2022/04/syria-un-experts-profoundly-concerned-missing-and-injured-children-after)</l>, 100 of them remain unaccounted for and are likely dead."
      +"\r\n\r\n One guard, known as Bawar, survived by standing guard at the top of a block of stairs for six days with a single gun.",
      "Text Image End": "Frames/AlSina_Frame518.jpg",         
    },
    {
      "Slide Number": "38",
      "Scroll Video":"100",
      "Card Empty":".",
    },
    {
      "Slide Number": "38",
      "Card Content":
      "ISIS fighters even tried to smoke him and his colleagues out by burning mattresses and other furniture.",
      "Scroll Video":"10",  
    },
    {
      "Slide Number": "40",
      "Card Content":
      "When he was eventually liberated, Bawar was photographed covered in soot flashing a victory sign.",
      "Scroll Video":"10",
    },
    {
      "Slide Number": "41",
      "Scroll Video":"100",
      "Text Image": "Frames/AlSina_Frame733.jpg"
    },
    {
      "Slide Number": "42",
      "Text Title": "AFTERMATH",
      "Text Long After": "In the year since the attack, discussion has turned to whether it could have been prevented - and who was to blame for the failure to do so."
      +'\r\n\r\n The SDF produced a review into the circumstances of the breakout but it remains classified. Amid allegations that a number of guards were assisting ISIS, a <l> report by the US Coalition(https://media.defense.gov/2022/Aug/05/2003050428/-1/-1/1/LEAD_INSPECTOR_GENERAL_FOR_OPERATION_INHERENT_RESOLVE_APRIL_1_.PDF)</l> to Congress found that the SDF had “relieved the entire guard force at the facility.” The same report concluded that at the time of the attack, the guard force were “undermanned, underequipped and undertrained."'
      +"\r\n\r\n The US has repeatedly denied that its actions made the breakout more likely. In an interview with VICE News, former US Special Representative for Syria Engagement James Jeffrey said they had many competing concerns in Syria, of which prison security was only one:"      
      +'\r\n\r\n "We looked into it at various points, and we ran into the fact that this was not a major priority.  So, on the list of problems we had, we basically did a triage - [prisons] seemed to be less worrisome than others."'
      +"\r\n\r\n <l>In early 2022(https://media.defense.gov/2022/May/03/2002988582/-1/-1/1/OIR_Q2_MAR2022_GOLD_508.PDF)</l> the US government removed the $4 million limit on infrastructure in Syria. In <l>November(https://media.defense.gov/2022/Nov/21/2003119338/-1/-1/1/LEAD%20INSPECTOR%20GENERAL%20FOR%20OIR.PDF)</l>,  the Department of Defense (DoD) announced it intended to fund another purpose-built detention facility for ISIS detainees near Hasakah. The DoD did not provide further details by the time of publication."  
      +"\r\n\r\n The UK declined to provide further information about the $20 million it spent on developing the prison facilities."
      +"\r\n\r\n In December 2022, ISIS militants attacked another detention facility in northern Syria - killing six guards. Reports indicate that ISIS is regrouping in new ways, drawing on its dormant militant population in camps and prisons around the region."      
      +'\r\n\r\n Since the attack, the US-led Coalition and the SDF have increased security and invested in prison infrastructure. Yet, in August 2022, a <l>Coalition report(https://media.defense.gov/2022/Aug/05/2003050428/-1/-1/1/LEAD_INSPECTOR_GENERAL_FOR_OPERATION_INHERENT_RESOLVE_APRIL_1_.PDF)</l> warned that the “fundamental security vulnerabilities that were in place prior to the attack remain.”'
      +"\r\n\r\n ___________________________________"
      +"\r\n\r\n Reporting from Airwars: <l> Joe Dyke(https://twitter.com/joedyke)</l>, <l>Sanjana Varghese(https://twitter.com/sanjanamv)</l>, <l>Imogen Piper(https://twitter.com/imogen_piper)</l>, <l>Júlia Nueno(https://twitter.com/julnueno)</l>"
      +"\r\n\r\n Reporting from Vice News: <l> Hind Hassan(https://twitter.com/HindHassanNews)</l>, <l>Lama Al-Arian(https://twitter.com/lalarian)</l>, Roberto Daza, <l> Andy Hayward (https://twitter.com/AndyJohnHayward) </l>, <l> Maya Rostowska (https://twitter.com/maya_rstw) </l>, <l> Gavin Butler (https://twitter.com/gav_butler) </l>"
      +"\r\n\r\n Visual Design: <l>Júlia Nueno(https://twitter.com/julnueno)</l>, <l>Imogen Piper(https://twitter.com/imogen_piper)</l>, Azul De Monte",
      "Share": 
      "https://airwars.org/syria-prison-break-isis-us-mistakes " 
    },
  ],
  frames: [
    {
      "Slide Num": "1",
      "Start Frame": "0",
      "End Frame": "23",
    },
    {
      "Slide Num": "2",
      "Start Frame": "24",
      "End Frame": "42",
    },
    {
      "Slide Num": "3",
      "Start Frame": "43",
      "End Frame": "58",
    },
    {
      "Slide Num": "4",
      "Start Frame": "58",
      "End Frame": "58",
    },
    {
      "Slide Num": "5",
      "Start Frame": "58",
      "End Frame": "58",
    },
    {
      "Slide Num": "6",
      "Start Frame": "58",
      "End Frame": "58",
    },
    {
      "Slide Num": "7",
      "Start Frame": "58",
      "End Frame": "68",
    },
    {
      "Slide Num": "8",
      "Start Frame": "69",
      "End Frame": "98",
    },
    {
      "Slide Num": "9",
      "Start Frame": "98",
      "End Frame": "98",
    },
    {
      "Slide Num": "10",
      "Start Frame": "98",
      "End Frame": "98",
    },
    {
      "Slide Num": "11",
      "Start Frame": "98",
      "End Frame": "98",
    },
    {
      "Slide Num": "12",
      "Start Frame": "99",
      "End Frame": "99",
    },
    {
      "Slide Num": "13",
      "Start Frame": "99",
      "End Frame": "99",
    },
    {
      "Slide Num": "14",
      "Start Frame": "99",
      "End Frame": "99",
    },
    {
      "Slide Num": "15",
      "Start Frame": "99",
      "End Frame": "99",
    },
    {
      "Slide Num": "16",
      "Start Frame": "99",
      "End Frame": "131",
    },
    {
      "Slide Num": "17",
      "Start Frame": "132",
      "End Frame": "266",
    },
    {
      "Slide Num": "18",
      "Start Frame": "266",
      "End Frame": "266",
    },
    {
      "Slide Num": "19",
      "Start Frame": "266",
      "End Frame": "266",
    },
    {
      "Slide Num": "20",
      "Start Frame": "267",
      "End Frame": "267",
    },
    {
      "Slide Num": "21",
      "Start Frame": "267",
      "End Frame": "267",
    },
    {
      "Slide Num": "22",
      "Start Frame": "267",
      "End Frame": "267",
    },
    {
      "Slide Num": "23",
      "Start Frame": "268",
      "End Frame": "310",
    },
    {
      "Slide Num": "24",
      "Start Frame": "311",
      "End Frame": "481",
    },
    {
      "Slide Num": "25",
      "Start Frame": "480",
      "End Frame": "509",
    },
    {
      "Slide Num": "26",
      "Start Frame": "510",
      "End Frame": "517",
    },
    {
      "Slide Num": "27",
      "Start Frame": "517",
      "End Frame": "517",
    },
    {
      "Slide Num": "28",
      "Start Frame": "734",
      "End Frame": "734",
    },
    {
      "Slide Num": "29",
      "Start Frame": "734",
      "End Frame": "734",
    },
    {
      "Slide Num": "30",
      "Start Frame": "734",
      "End Frame": "830",
    },
    {
      "Slide Num": "31",
      "Start Frame": "831",
      "End Frame": "900",
    },
    {
      "Slide Num": "32",
      "Start Frame": "901",
      "End Frame": "927",
    },
    {
      "Slide Num": "33",
      "Start Frame": "927",
      "End Frame": "927",
    },
      {
      "Slide Num": "34",
      "Start Frame": "518",
      "End Frame": "518",
    },
    {
      "Slide Num": "35",
      "Start Frame": "519",
      "End Frame": "620",
    },
        {
      "Slide Num": "36",
      "Start Frame": "621",
      "End Frame": "733",
    },
    {
      "Slide Num": "37",
      "Start Frame": "733",
      "End Frame": "733",
    },
    {
      "Slide Num": "38",
      "Start Frame": "733",
      "End Frame": "733",
    },
  ],
}

export default data;